"use client";
import { usePanelTitleHandler } from "@/hooks";
import { useTranslations } from "next-intl";
import { getFromLocale } from "@/utils";
import { usePathname, useRouter } from "next/navigation";

export const PanelTitle = ({
  titleBlog,
  subTitleBlog,
  sectionName,
  domainDesc = false,
  colourGroup = "whiteGroup",
  bt = false,
  posGroup = "center",
}) => {
  const { parentPos, childPos, title, subTitle, tColour, subTColour, mBt } =
    usePanelTitleHandler({ sectionName, colourGroup, bt, posGroup }) || {};

  const subTitleWidth =
    sectionName === "any_question" ? "max-w-[856px]" : "max-w-[636px]";
  const finalTitle = titleBlog ?? title;
  const finalSubTitile = subTitleBlog ?? subTitle;
  const t = useTranslations();
  const navigate = useRouter();
  const location = usePathname();

  const type = getFromLocale("typeWebsite") || 1;
  function getTypeWebsite(type) {
    return type === 1 ? "Sayt.az" : "Websiteca.com";
  }
  const websiteName = getTypeWebsite(type);

  return (
    <div className="max-w-[1296px] w-full mx-auto">
      <div
        className={`flex w-full mx-auto flex-col gap-2 ${mBt} justify-center ${
          parentPos ?? ""
        }`}
      >
        <h1
          className={`sm:text-[22px] sm:leading-[44px] tracking-[0.1px] sm:text-center md:text-[32px] font-medium ${tColour ?? 'text-white'} leading-[38px] p-0`}
        >
          {finalTitle}
        </h1>
        {finalSubTitile && (
          <h2
            className={`sm:!text-cener sm:p-2 sm:text-base sm:font-normal sm:tracking-[0.1px] text-[20px] md:p-0 ${subTitleWidth} ${subTColour} p-0 m-0 ${childPos} md:text-center md:mx-auto`}
          >
            {finalSubTitile}
          </h2>
        )}
        {domainDesc && (
          <>
            <p
              className={`sm:!text-cener sm:p-2 sm:text-base sm:font-normal sm:tracking-[0.1px] text-[20px] md:p-0 ${subTitleWidth} ${subTColour} p-0 m-0 ${childPos} md:text-center md:mx-auto`}
            >
              {t("domainDescBefore")}
              <span className="font-bold">{t("domainNameSearch")}</span>
              {t("domainDescAfter")}
            </p>
            <span
              className={`sm:!text-cener sm:p-2 sm:text-base sm:font-normal sm:tracking-[0.1px] text-[20px] md:p-0 ${subTitleWidth} ${subTColour} p-0 m-0 ${childPos} md:text-center md:mx-auto font-medium`}
            >
              {t("az_domain_has_hosting", { sayt: websiteName })}
              <span
                className="cursor-pointer"
                onClick={() => navigate.push("/terms")}
              >
                {t("more")}
              </span>
            </span>
          </>
        )}
      </div>
    </div>
  );
};
